// extracted by mini-css-extract-plugin
module.exports = {"root":"Head_root__1qHW2","addColumnButton":"Head_addColumnButton__3LDIB","editMode":"Head_editMode__STR6C"};